import { render } from "./vulnerabilities.vue?vue&type=template&id=205319f6&scoped=true&ts=true"
import script from "./vulnerabilities.vue?vue&type=script&lang=ts"
export * from "./vulnerabilities.vue?vue&type=script&lang=ts"

import "./vulnerabilities.vue?vue&type=style&index=0&id=205319f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-205319f6"]])

export default __exports__